











































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { getCurrentGroup } from '@/router';
import { getGroupById } from '@/router';
import { Route } from '@/router/route.model';
import { isRootUser } from '@/utils/auth';
import APIService from '@/api';

import CheckIcon from '@/components/icons/Check.vue';
import eventBus from '@/utils/eventBus';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import flagKeys from '@/constants/flagKeys';

type Item = Route & {
  id: string;
  translatedTitle: string;
};

@Component({
  components: {
    CheckIcon
  }
})
export default class ActionSheetMenu extends Vue {
  @Prop({ default: () => [] }) items!: Array<Item>;
  @Prop() notificationMenu?: any;

  opened = false;
  activePath = '';
  activeRoute = '';

  @Watch('$route', { immediate: true })
  onRouteChange() {
    const group = getCurrentGroup();

    this.activePath = group.path;
    this.activeRoute = this.$t(`menus.topbar.${group.id}`).toString();
    this.onToggleMenu(false);
  }

  get isNotification() {
    return !!this.notificationMenu.length;
  }

  get showWhatsNew() {
    return this.getFlags.includes(flagKeys.whatIsNew);
  }

  get getFlags() {
    return this.$store.getters['flags/getFlags'];
  }

  get profileMenu() {
    if (isRootUser()) {
      return [];
    }

    const group = getGroupById('auth-menu');
    if (!group) {
      return [];
    }

    const unavailableItemsOnMobile = ['settings_password'];
    return group
      .getVisibleRoutes()
      .filter(route => !unavailableItemsOnMobile.includes(route.name));
  }

  get transformedProfileItems() {
    return this.profileMenu.map(route => ({
      ...route,
      path: route.path,
      translatedTitle: this.$t(
        `menus.topbar.profileMenuDrop.navbarMenu.${route.name}`
      )
    }));
  }

  get transformedItems() {
    return this.items.map(route => ({
      ...route,
      path: route.path,
      translatedTitle: this.$t(`menus.topbar.${route.id}`)
    }));
  }

  get translatedItems() {
    return [...this.transformedItems, ...this.transformedProfileItems];
  }

  onToggleMenu(opened: boolean) {
    if (!opened) eventBus.$emit('clearNotificationMenu');
    this.opened = opened;
    const el = document.getElementById('app');
    if (el) el.style.overflow = this.opened ? 'hidden' : 'inherit';
  }

  getIsNotificationMenuByName(name: string) {
    return this.notificationMenu.includes(name);
  }

  logout() {
    APIService.resetCredentials();
  }

  openWhatIsNew() {
    this.onToggleMenu(false);
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: 'whatIsNewModal',
        hideCancelButton: false,
        icon: '',
        mobilePositionBottom: true,
        mobileFullScreen: false
      })
    );
  }
}
